export default __webpack_public_path__ + "static/media/phonebg3.3862feb4.svg";